import React from "react";
import { Flex, Tooltip, Avatar, Popover } from "antd";
import profile from "../../../images/avatar.png";
import { ExtraSmallTitle, SmallTitle, Title5 } from "components/Common/Typography/Titles";

const BulkMailCandidate = ({ candidates }: any) => {
    const maxVisible = 10;

    if (!Array.isArray(candidates) || candidates.length === 0) return null;

    const mainCandidate = candidates[0];
    const otherCandidates = candidates
        .filter((c: any) => c?.id && c.id !== mainCandidate?.id) // ✅ exclude main candidate
        .filter(
            (c: any, index: number, self: any[]) =>
                index === self.findIndex((x) => x.id === c.id) // ✅ remove duplicates by id
        );

    const visibleCandidates = otherCandidates.slice(0, maxVisible - 1);
    const hiddenCandidates = otherCandidates.slice(maxVisible - 1);

    const renderAvatar = (candidate: any) => (
        <Tooltip title={candidate?.name} placement="top" key={candidate?.id || candidate?.email || Math.random()}>
            <Avatar
                size="small"
                style={{ backgroundColor: "#87d068" }}
                icon={<img src={candidate?.profile || profile} />}
            />
        </Tooltip>
    );

    return (
        <Flex gap={12} align="center">
            <Avatar icon={<img src={mainCandidate?.profile || profile} />} />
            <Flex vertical>
                <div className="flex items-center gap-2">
                    <SmallTitle
                        text={mainCandidate?.name || "No Name"}
                        className="text-fonttext-primary"
                    />
                    <ExtraSmallTitle
                        text={mainCandidate?.location || "No Location"}
                        className="text-text-quaternary font-normal"
                    />
                </div>
                <Title5
                    text={mainCandidate?.jobTitle || "No designation"}
                    className="text-[#101828] text-base font-medium"
                />
            </Flex>

            {otherCandidates.length > 0 && (
                <Flex gap={-8} className="flex-wrap">
                    {visibleCandidates.map(renderAvatar)}

                    {hiddenCandidates.length > 0 && (
                        <Popover
                            trigger="click"
                            placement="top"
                            content={
                                <div className="flex flex-wrap gap-2 max-w-[200px]">
                                    {hiddenCandidates.map(renderAvatar)}
                                </div>
                            }
                        >
                            <Avatar
                                size="small"
                                style={{
                                    backgroundColor: "#f0f0f0",
                                    color: "#555",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                }}
                            >
                                ...
                            </Avatar>
                        </Popover>
                    )}
                </Flex>
            )}
        </Flex>
    );
};

export default BulkMailCandidate;
